import React from 'react';
import { FileUpload } from '@emorg-prd/standard-react';
import CSVGeneratorButton from '../../../common/CSVGeneratorButton';
import { ObjectColumnsLayout, ObjColumn } from '../ObjectColumnsLayout';
import OnPremPORequestObjectService from '../../../../services/OnPremPORequestObjectService';
import PortOpeningObjectRuleOnPrem from '../../../../models/entities/OnPremPortOpeningObject';
import StandardModal from '../../../common/modals/StandardModal';
import { Button, ButtonGroup, Icon } from '../../../common';
import { Alert } from '../../../common';

interface BulkUploadModalProps {
	onSuccess: (rules: PortOpeningObjectRuleOnPrem[]) => any;
	onCancel: (...args: any[]) => any;
	visible: boolean;
}

interface BulkUploadModalState {
	loading: boolean;
	file: any;
	fileKey: number;
	alert: {
		visible: boolean;
		text?: string;
	},
	templateColumns: ObjColumn[];
}

export default class BulkUploadModal
	extends React.Component<BulkUploadModalProps, BulkUploadModalState> {
	
	onPremPORequestObjectService: OnPremPORequestObjectService;

	constructor(props: BulkUploadModalProps) {
		super(props);
		this.onPremPORequestObjectService = new OnPremPORequestObjectService();
		this.state = {
			loading: false,
			file: null,
			fileKey: 0,
			alert: {
				visible: false,
			},
			templateColumns: []
		};
	}

	componentDidMount() {
		this.setColumns();
	}

	handleChange = (file) => {
		this.setState({
			file: file[0],
			alert: {
				visible: false,
			}
		});
	};

	handleUpload = async () => {
		try{
			this.setState({ loading: true });
			await this.onPremPORequestObjectService.parse(this.state.file)
			.then((response: PortOpeningObjectRuleOnPrem[]) => {
				const rules = response.map(r => new PortOpeningObjectRuleOnPrem(r));
				this.props.onSuccess(rules);
			});
		}catch(err){
			this.handleFileRemoval();
			this.setState({
				alert: {
					visible: true,
					text: err.message
				}
			});
		}finally{
			this.setState({
				loading: false,
				file: null,
				templateColumns: [],					
			});
		}
	};

	handleCancel = () => {
		this.setState({
			loading: false,
			file: null,
			templateColumns: []
		});
		this.props.onCancel();
	}

	handleFileRemoval = () => {
		this.setState((prev) => ({
			file: null,
			fileKey: prev.fileKey + 1,
			alert: { visible: false },
		}));
	}

	setColumns = () => {
		this.setState({
			templateColumns: ObjectColumnsLayout
		});
	};

	render() {
		return (
			<StandardModal
				show={this.props.visible}
				title="Import objects to the request"
				onDismiss={this.handleCancel}
				footer={
					<ButtonGroup>
						<Button
							variant="primary"
							onClick={this.handleUpload}
							isLoading={this.state.loading}
							disabled={(!this.state.file) || this.state.alert.visible}
						>
							Upload Objects
						</Button>
						<Button
							variant="secondary"
							onClick={this.handleFileRemoval}
							isLoading={this.state.loading}
							disabled={(!this.state.file) || this.state.alert.visible}
						>
							<Icon icon='trashcan' size='small' className={"em-u-margin-right-half"}></Icon>
							Remove File
						</Button>
					</ButtonGroup>
				}
			>
				<CSVGeneratorButton
					label="Download Template"
					columns={this.state.templateColumns ?? []}
					fileName={`Template-OnPrem-Objects.csv`}
					data={[]}
				/>
				<FileUpload
					key={this.state.fileKey}
					multiple={false}
					onChange={this.handleChange}
				/>
				{this.state.alert.visible &&
					<Alert
						variant="error"
						body={this.state.alert.text}
						onClose={() => {
							this.setState({ alert: { visible: false } });
						}}
					>
						{this.state.alert.text}
					</Alert>}
			</StandardModal>
		);
	}
}